export default () => ({
    selectedPhotosLabel(totalSelectedImages, totalImages, allSelected, totalUnselectedImages) {
        if ((allSelected && !totalUnselectedImages) || (totalSelectedImages === totalImages && totalImages > 0)) {
            return 'All photos selected';
        }

        if (!totalSelectedImages && !allSelected) {
            return 'No photos selected';
        }

        return this.getSelectionLabel(totalSelectedImages);
    },

    getSelectionLabel(total) {
        return total + ' ' + 'photo' + `${total <= 1 ? '' : 's'}` + ' ' + 'selected';
    }
})
